export default __webpack_public_path__ + "static/bz-cd298eed7f138ec032418203076b090c.svg";